module.exports = __webpack_public_path__ + "static/cake_birthday_lettering_03-b3fc727bb7247102bd7a84465b08fad9.jpg";